import emptyArray from './emptyArray'

export default (array) => Array.isArray(array) && array.length > 0 ? array : emptyArray
